<template>
    <div class="rm-accordion-wrap">
        <div v-for="item in list" v-bind:key="item.title">
            <div class="rm-accordion-title" layout-padding>
                <div class="rm-accordion-title-wrap">
                    <h2 tabindex="0">{{item.title}}</h2>
                </div>
                <div class="expand-button-wrap">
                    <button v-on:click="toggle(item)" class="expand-icon" v-bind:class="{ expanded: !item.collapse }">
                        <span></span>
                    </button>
                </div>
            </div>
            <div v-show="!item.collapse && !item.component" class="rm-accordion-content" v-bind:class="{ expanded: !item.collapse }" v-html="item.content"></div>
            <div v-show="!item.collapse && item.component" class="rm-accordion-content" v-bind:class="{ expanded: !item.collapse }">
                <component :is="component" v-bind="item.props"></component>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'rm-accordion',
    data: function () {
        return {
            count: 0,
            component: null
        }
    },
    components: { },
    props: {
        list: Array
    },
    computed: { },
    mounted () { },
    methods: {
        toggle: function (item, e) {
            item.collapse = !item.collapse
            if (item.component) {
                import('./' + item.component).then(loadedComponent => {
                    this.component = loadedComponent.default ? loadedComponent.default : null
                    console.log('component', this.component)
                }).catch(err => {
                    console.log('err', err)
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/rm-accordion.vue